import * as react from "react";

export function useLocalStorage(key, defaultValue) {
    const localStorageState = react.useState((() => {
        const data = localStorage.getItem(key);
        return (data === null) ? defaultValue : JSON.parse(data);
    }));
    react.useEffect(() => {
        localStorage.setItem(key, JSON.stringify(localStorageState[0]));
    }, [[localStorageState[0], key]]);
    return localStorageState;
}

